export default __webpack_public_path__ + "static/comercial-trash-service-banner-9972dc3491a030d27290fd67fc9f1153.jpg";